export const filterFTTHSpeeds = coverage => {
  if (!coverage) return coverage
  const { technology, speeds } = coverage
  if (technology !== 'FTTH') return coverage
  const available_speeds = ['50M', '100M', '300M']
  const finalSpeeds = speeds.filter(elem => available_speeds.find(speed => speed === elem))
  return { technology, speeds: finalSpeeds }
}
